var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EntitiesList',{attrs:{"items":_vm.value,"headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }